module.exports = __webpack_public_path__ + "static/media/joinus-banner.8860fce8.png";